import EmptyStateNotice from '../EmptyStateNotice.jsx';
import { VscTelescope } from '../react-icons/main';
import DividerV2 from '../v2/DividerV2.jsx';
import PanelActionButton from './PanelActionButton.jsx';
import PanelAlert from './PanelAlert.jsx';
import PanelBody from './PanelBody.jsx';
import PanelButton from './PanelButton.jsx';
import PanelFeatureBox from './PanelFeatureBox.jsx';
import PanelFooter from './PanelFooter.jsx';
import PanelHeader from './PanelHeader.jsx';
import PanelInput from './PanelInput.jsx';
import PanelLexicalInput from './PanelLexicalInput.jsx';
import PanelSection from './PanelSection.jsx';
import PanelSelect from './PanelSelect.jsx';
import PanelTabs from './PanelTabs.jsx';
import PanelToggle from './PanelToggle.jsx';
import PanelToggleButton from './PanelToggleButton.jsx';

const Panel = {};

const Divider = () => <DividerV2 className="no-margin" />;
const EmptyState = ({ title, description, actions, icon, className, helpIconContext, content, loading = false }) => {
  return <EmptyStateNotice size={'sm'} icon={icon || VscTelescope} loading={loading} className={`workflow ${className}`} title={title} description={description} actions={actions} helpIconContext={helpIconContext} content={content} />;
};

Panel.Body = PanelBody;
Panel.Footer = PanelFooter;
Panel.Header = PanelHeader;
Panel.FixedContent = PanelBody.FixedContent;
Panel.ScrollableContent = PanelBody.ScrollableContent;
Panel.Section = PanelSection;
Panel.Divider = Divider;
Panel.EmptyState = EmptyState;
Panel.FeatureBox = PanelFeatureBox;
Panel.Alert = PanelAlert;
Panel.Tabs = PanelTabs;

// Inputs
Panel.Select = PanelSelect;
Panel.ToggleButton = PanelToggleButton;
Panel.Toggle = PanelToggle;
Panel.Button = PanelButton;
Panel.Input = PanelInput;
Panel.LexicalInput = PanelLexicalInput;
Panel.ActionButton = PanelActionButton;

export default Panel;
